import PropTypes from 'prop-types'
import {Checkbox, FormControlLabel} from '@mui/material'
import {
  StyledDialogButton,
  StyledDialog,
  StyledDialogActions,
  StyledDialogContent,
  StyledDialogTitle,
  StyledCancelButton
} from './UserFeedbackDashboardStyle'

const UserFeedbackDialog = ({open, onClose, onConfirm, doNotShowAgain, setDoNotShowAgain}) => {
  return (
    <StyledDialog open={open} onClose={onClose}>
      <StyledDialogTitle>End Session and Save Recording</StyledDialogTitle>
      <StyledDialogContent>
        <p>
          Ending the session will save the participant activity recording. Are you sure you want to end the session?
        </p>
        <FormControlLabel
          control={<Checkbox checked={doNotShowAgain} onChange={(e) => setDoNotShowAgain(e.target.checked)} />}
          label='Do not show this message to me again'
        />
      </StyledDialogContent>
      <StyledDialogActions>
        <StyledCancelButton onClick={onClose} variant='outlined'>
          Cancel
        </StyledCancelButton>
        <StyledDialogButton onClick={onConfirm} variant='contained' color='success'>
          End & Save
        </StyledDialogButton>
      </StyledDialogActions>
    </StyledDialog>
  )
}

UserFeedbackDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  doNotShowAgain: PropTypes.bool.isRequired,
  setDoNotShowAgain: PropTypes.func.isRequired
}

export default UserFeedbackDialog
